import React from "react";

import HeroSection from './HeroSection.js';
import WhoWeAre from './WhoWeAre.js';
import ExperienceSection from './ExperienceSection.js';
import GmSignalToOutcome from "./GmSignalToOutcome.js";
import Offerings from './Offerings.js';
import GmTestimonials from './GmTestimonials.js'
import LifeAtGlobalManch from "./LifeAtGlobalManch.js";
import ConversationHero from "./ConversationHero.js";
import ConversationThemes from "./ConversationThemes.js";
import CultureMindsets from "./CultureMindsets.js";


const Home = () => {
    return (
        <>
            <HeroSection />
            <Offerings />
            <WhoWeAre />
            <ExperienceSection />
            <GmSignalToOutcome />
            <GmTestimonials />
            {/* <LifeAtGlobalManch /> */}
            {/* <ConversationHero /> */}
            {/* <ConversationThemes /> */}
            {/* <CultureMindsets /> */}


        </>
    );
};

export default Home;
